import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  count?: number;
}

export function AddCardToBinderOptionsSkeleton({ count = 6 }: Props) {
  return (
    <div className="grid gap-2">
      <Skeleton className="h-5 w-28" />
      <div className="flex gap-2 overflow-x-auto ">
        {Array.from({ length: count }).map((_, index) => (
          <Skeleton key={index} className="h-6 w-20 rounded-lg" />
        ))}
      </div>
    </div>
  );
}
